import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';
import { getQueryKeys } from '../../../../queries/queryKeys';

const fetchArrearTypes = async ({ houseIds }) => {
  const res = await request.post(
    `/HousingStock/house/arrear_types`,
    { houseIds },
    'Не удалось загрузить типы ЛС'
  );

  return res;
};

const useArrearTypes = (params = {}, options = {}) =>
  useQuery(
    getQueryKeys.arrearTypes(params),
    () => fetchArrearTypes(params),
    options
  );

export { useArrearTypes };
